<template>
  <div id="candidate_resume.school_category_id" class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">最終学歴</label>
        <div class="d-flex ms-2">
          <span class="tag-thirdly size-10 ms-2">必須</span>
        </div>
      </div>
      <div class="row p-0">
        <div class="col-12 col-md-4 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="resumeEducation.school_category_id"
            name="candidate_resume.school_category_id"
          >
            <select
              class="form-select select-input-primary size-14 p-0d8"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            >
              <option v-for="category in categories" :key="category.id" :value="category.id">
                {{ category.name }}
              </option>
            </select>
            <ErrorMessage name="candidate_resume.school_category_id" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useResumeEducationStore } from '@/stores/resume-candidate/ResumeEducation.store';
import { getSchoolCategory } from '@/apis/candidate';
import { SchoolCategory } from '@/types/models/SchoolCategory';
import { Field, ErrorMessage } from 'vee-validate';

const categories = ref<SchoolCategory[]>([]);
const resumeEducation = useResumeEducationStore();

onMounted(() => {
  loadCategorySchools();
});

const loadCategorySchools = async (): Promise<void> => {
  const response = await getSchoolCategory();
  if (response.status === 200) categories.value = response.data;
};
</script>
